import { useIwRecordingStore } from '@/entities/interwills/stores/iwRecording.store';
import { useNotices } from '@/features/notices/useNotices';
import { useApi } from '@/shared/api';
import { DtoId } from '@/shared/lib/sj-orm/models/base.dto';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

export const useDeleteVerificationVideo = () => {
  const { t } = useTranslation('pages/pageInterwillVerification', { keyPrefix: 'videoCard' });

  const {
    testator,
    witnesses,
    witnessesDecoded,
    setWintesses,
    setTestator,
    setTestatorDecoded,
    setWitnessesDecoded,
  } = useIwRecordingStore();

  const notices = useNotices();
  const api = useApi();

  return async (witnessId?: DtoId) => {
    if (witnessId) {
      const newWitnesses = { ...witnesses };
      const newWitnessesDecoded = { ...witnessesDecoded };

      if (newWitnesses[witnessId]?.url) {
        await api.filesDeleteFile(newWitnesses[witnessId].url);
      }
      newWitnesses[witnessId] = null;
      newWitnessesDecoded[witnessId] = null;
      setWintesses(newWitnesses);
      setWitnessesDecoded(newWitnessesDecoded);
      notices.success(t('successMsg'));
      return;
    }

    if (!testator?.url) {
      setTestator(null);
      setTestatorDecoded(null);

      return;
    }

    await api.filesDeleteFile(testator.url);

    setTestator(null);
    setTestatorDecoded(null);
    notices.success(t('successMsg'));
  };
};
